import { render, staticRenderFns } from "./GraphCanvas3D.vue?vue&type=template&id=6b2fbda9&"
import script from "./GraphCanvas3D.vue?vue&type=script&lang=js&"
export * from "./GraphCanvas3D.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports